import apiClient from '@/services/axios'

export async function get(venueId) {
    var response = await apiClient.get(`/Idam/User/Roles/Active`, {
        headers: {
            venueId: venueId
        }
    })
    if (response) {
        return response.data
    }

    throw new Error('Unable to get active user roles')
}
